module.exports = __webpack_public_path__ + "media/npc_dota_hero_ursa.c9403366.webm";